import "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
import { stylable as e } from "../decorators/stylable.js";
const r = t({
  type: { default: "orderedList" }
}), s = t({
  type: { default: "unorderedList" }
}), p = e({
  content: "listItem+",
  attrs: r,
  group: "list",
  parseDOM: [{ tag: "ol" }],
  toDOM() {
    return ["ol", 0];
  }
}), u = e({
  content: "listItem+",
  attrs: s,
  group: "list",
  parseDOM: [{ tag: "ul" }],
  toDOM() {
    return ["ul", 0];
  }
}), a = {
  content: "paragraph",
  group: "listItem",
  parseDOM: [{ tag: "li" }],
  toDOM() {
    return ["li", 0];
  },
  defining: !0
}, o = t({
  type: { default: "orderedNestedList" }
}), n = t({
  type: { default: "unorderedNestedList" }
}), c = {
  content: "nestedListItem+",
  attrs: o,
  group: "list",
  parseDOM: [{ tag: "ol" }],
  toDOM() {
    return ["ol", 0];
  }
}, L = {
  content: "nestedListItem+",
  attrs: n,
  group: "list",
  parseDOM: [{ tag: "ul" }],
  toDOM() {
    return ["ul", 0];
  }
}, g = {
  content: "block (block | list)*",
  defining: !0,
  parseDOM: [{ tag: "li" }],
  toDOM() {
    return ["li", 0];
  }
};
export {
  a as listItemSpec,
  g as nestedListItemSpec,
  p as orderedListSpec,
  c as orderedNestedListSpec,
  u as unorderedListSpec,
  L as unorderedNestedListSpec
};
